import { mergeRight } from "ramda";

export const merge = <T extends object>(initial: T, update: Partial<T>) =>
  mergeRight(initial, update);
